import { render, staticRenderFns } from "./company-officers.vue?vue&type=template&id=a1cef2ca"
import script from "./company-officers.vue?vue&type=script&lang=js"
export * from "./company-officers.vue?vue&type=script&lang=js"
import style0 from "./company-officers.vue?vue&type=style&index=0&id=a1cef2ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports